import { Injectable } from '@angular/core';
import { CheckboxFilterControl, FilterGroup, SearchFilterControl } from '@vendasta/va-filter2';

@Injectable()
export class ListingSyncTableFilterService {
  filters: FilterGroup = new FilterGroup('listings_table');
  constructor() {
    this.filters
      .addToolbarSection(new SearchFilterControl('search'))
      .addSection('LISTING_SYNC.TABLE_FILTERS.SYNC_STATUS_FILTER.GROUP_LABEL', [
        new CheckboxFilterControl(
          'syncing_available',
          'LISTING_SYNC.TABLE_FILTERS.SYNC_STATUS_FILTER.SYNCING_AVAILABLE',
          false,
          {
            appliedValueMapper: (name) => ({
              name,
              label: 'LISTING_SYNC.TABLE_FILTERS.SYNC_STATUS_FILTER.SYNCING_AVAILABLE',
            }),
          },
        ),
        new CheckboxFilterControl(
          'manual_update_only',
          'LISTING_SYNC.TABLE_FILTERS.SYNC_STATUS_FILTER.MANUAL_UPDATE_ONLY',
          false,
          {
            appliedValueMapper: (name) => ({
              name,
              label: 'LISTING_SYNC.TABLE_FILTERS.SYNC_STATUS_FILTER.MANUAL_UPDATE_ONLY',
            }),
          },
        ),
      ]);
  }
}
